<div class="layout-footer">
    <span class="font-medium ml-2">Southern Oracle Micropro &copy; 2024</span>
</div>
